export default "__VITE_ASSET__ad5614eb__"